import React from 'react'
import { DiagnosticReportBundle } from '../../../../types/FHIRTypes/Bundle'
import DiagnosticReportList from './DiagnosticReportList'
import DiagnosticReportDetail from './DiagnosticReportDetail'

type DiagnosticReportProps = {
    page: string | undefined;
    diagnosticReportDetailId: string | undefined;
    isFetching: boolean;
    handleChangePage: (page: number) => void
    diagnosticReportData?: DiagnosticReportBundle;
    totalPages: number;
    currentPage: number;
}

const DiagnosticReport: React.FC<DiagnosticReportProps> = ({ page, diagnosticReportDetailId, isFetching, handleChangePage, diagnosticReportData, totalPages, currentPage }) => {

    return (
        <>
            {
                diagnosticReportDetailId && page === 'DiagnosticReport'
                    ? (
                        <DiagnosticReportDetail
                            diagnosticReportDetailId={diagnosticReportDetailId}
                        />
                    )
                    : (
                        <DiagnosticReportList
                            diagnosticReportsData={diagnosticReportData}
                            isFetching={isFetching}
                            handleChangePage={handleChangePage}
                            totalPages={totalPages}
                            currentPage={currentPage}
                        />
                    )
            }
        </>
    )
}

export default DiagnosticReport